import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-ssh-lookup',
  templateUrl: './micro-ssh-lookup.component.html'
})
export class MicroSshLookupComponent  {

  @Input()
  sshId:any;
}
